import React, { useContext } from "react";
import { CallsContext } from "../../providers/CallsContext";
import IndividualCallScreen from "./components/IndividualCallScreen";

const ActiveCallWrapper: React.FC = () => {
  const { activeCallProps, callStage } = useContext(CallsContext);

  if (activeCallProps || callStage !== "off") {
    return <IndividualCallScreen />;
  }

  return null;
};

export default ActiveCallWrapper;
